import React, { memo, useState } from "react";
import {
  Badge,
  Box,
  InlineStack,
  RadioButton,
} from "@shopify/polaris";

import ShopifyModal from "../../../../components/ShopifyModal";
import intl from "../../../../i18n/intl";
import SymbolTake from "../../../../components/SymbolTake";

const BulkPaymentModal = memo(
  ({
    paymentData,
    setIsShowBulkPaymentModal,
    handlePayForOrderModal,
    walletMoney,
  }) => {
    const [value, setValue] = useState("dsm");
    const [type, setType] = useState(0);
    const [loading, setLoading] = useState(false);
  
    const handleRadioChange = (_, newValue) => {
      //单选按钮点击事件
      setValue(newValue);
      switch (newValue) {
        case "dsm":
          setType(2);
          break;
        case "pal":
          setType(1);
          break;
        
        default:
          break;
      }
    };

   
    // 选中付款方式，确认付款
    const handleSelectPaymentToPay = () => {
      setLoading(true);
      let ids = paymentData.batchPayOrderIds;
      let payment_dsm_number = paymentData.toPayOrderName;
      let totalPrice = paymentData.totalPrice;
      // 获取选择付款的方式

      let payment_select_value = Number(type);
     
      
      handlePayForOrderModal(
        ids,
        payment_dsm_number,
        payment_select_value,
        totalPrice
      );
      // 关闭付款方式选择弹窗
      handleOff();
      setLoading(false);
    };

    const handleOff = () => {
      //恢复默认
      setValue("dsm");
      setLoading(false);
      setType(0);
      setIsShowBulkPaymentModal();
     
    };

    
    const contentNode = () => {
      return (
        <div>
          
            <Box>
              <div className="order_banner">
               
                 {paymentData?.toPayOrderName.map((item,ind)=>
                  <span key={ind} className="order_banner_span"><Badge  tone="info">{item}</Badge></span>)}
              </div>
              <div
                className="pay_sp"
                style={{ lineHeight: "28px", marginTop: 5 }}
              >
                {/*开辟新Modal框内容新增优惠券*/}
                <InlineStack align="space-between">
                  <span style={{ fontWeight: "700" }}>
                    {intl.get("Orders")}
                  </span>
                  <span className="sp_clo">
                    {paymentData?.toPayOrderName.length}
                  </span>
                </InlineStack>
                <InlineStack align="space-between">
                  <span style={{ fontWeight: "700" }}>
                    {intl.get("Total cost")}
                  </span>
                  <span className="sp_clo">
                  <SymbolTake price={(paymentData?.totalPrice).toFixed(2)} /> USD
                  </span>
                </InlineStack>
                
              </div>
            </Box>
            <Box>
              <div>
                <span style={{ fontWeight: "550" }}>
                  {intl.get("Payment method")}
                </span>
              </div>
              <div className="radio_container_box">
              <div className="radio_container">
                <div
                  className={`${
                    type === 2
                      ? "dsm_container_border dsm_container"
                      : "dsm_container"
                  } `}
                >
                  <div className="dsm_radioLabel">
                        <div>
                          <img src="/dsm_pay.png" alt="dropshipman" />
                        </div>
                        <div>
                          <div style={{ fontWeight: "550" }}>
                            {intl.get("Dropshipman Credits")}
                          </div>
                          <div style={{ color: "rgba(12, 81, 50, 1)" }}>
                            ${walletMoney} USD
                          </div>
                        </div>
                      </div>
                  <RadioButton
                    id="dsm"
                    name="dsm_pay"
                    disabled={walletMoney <= 0}
                    checked={type !== 0 && value === "dsm"}
                    onChange={handleRadioChange}
                  />
                </div>
              
                <div
                  className={`${
                    type === 1
                      ? "dsm_container_border dsm_container"
                      : "dsm_container"
                  } `}
                >
                  <div className="pay_radioLabel">
                        <div>
                          <img src="/pay_pal.png" alt="dropshipman" />
                        </div>
                        <div style={{ fontWeight: "550" }}>
                          {intl.get("PayPal")}
                        </div>
                      </div>
                  <RadioButton
                   
                    id="pal"
                    name="pal_pay"
                    checked={type !== 0 && value === "pal"}
                    onChange={handleRadioChange}
                  />
                </div>
               
              </div>
              </div>
            </Box>
            <InlineStack align="space-between">
                  <span style={{ fontWeight: "700" }}>
                    {intl.get("Actual payment")}
                  </span>
                  <span style={{ fontWeight: "700" }}>
                  <SymbolTake price={(paymentData?.totalPrice).toFixed(2)} /> USD
                  </span>
                </InlineStack>
               
          
        </div>
      );
    };

    return (
      <div>
        <ShopifyModal
          id="bulk-payment-additional-modal"
          open={paymentData.isShowBulkPaymentModal}
          // open={true}
          onClose={() => handleOff()}
          heading={paymentData?.batchPayOrderIds.length > 1 ? "Bulk Payment" : "Order Payment"}
          primaryAction={{
            content: intl.get("Pay"),
            onAction: handleSelectPaymentToPay,
            loading: loading,
            disabled: type === 0 ? true : false,
          }}
        >
          {contentNode()}
          <InlineStack wrap={false}>
            <img style={{marginRight:8}} width={20} src="/sub/points_icon.png" alt="Dropshipman" /> 
            <span>
              You'll receive <strong>{paymentData?.totalPrice.toFixed(0)} points </strong>
              once you complete this payment.
            </span>
          </InlineStack>
        </ShopifyModal>
      </div>
    );
  }
);

export default BulkPaymentModal;
